import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

const Spinner = props => {
    const {
        message
    } = props;

    useEffect(() => {
        const disableScroll = () => window.scrollTo(0, 0);
        window.addEventListener('scroll', disableScroll);
        return () => window.removeEventListener('scroll', disableScroll);
    });

    return (
        <div className="gi-roller-container">
            <div className="gi-roller-wrapper">
                <div className="gi-roller-message">
                    <FormattedMessage id={message} />
                </div>
                <div className="gi-roller-spin">
                    {Array.from({ length: 8 }, () => <div key={Math.random()}/>)}
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = state => ({
    language: state.common.environment.language
});


export default connect(mapStateToProps)(Spinner);
